<div class="container-fluid" [ngClass]="classPx + ' ' + classPy">
    <div class="row">
        <div class="col-12" [ngClass]="colAdditionalClass">
            <ng-content></ng-content>
        </div>
    </div>
</div>
